/**
 * Left detail panel tab strip for the HERO Dokumente detail view.
 */
import { ld } from "@/lib/theme/light-dark";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
import { useState } from "react";

import { H } from "../../hero-tokens";
import {
  type DocDetailFixture,
  type DocDetailTab,
  detailTabs,
} from "./module-dokumente-data";
import { DokumenteDetailTabPanel } from "./module-dokumente-detail-tab-bodies";

export function DokumenteDetailTabs(props: {
  readonly fixture: DocDetailFixture;
}): ReactNode {
  const t = useTranslations("marketing.moduleDokumenteData");
  const [activeTab, setActiveTab] = useState<DocDetailTab>("details");
  const tabs = detailTabs(t);

  return (
    <div
      style={{
        width: 320,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        borderRight: `1px solid ${ld("#EEF0F3", "#2c2f33")}`,
        background: ld("#fff", "#181b1f"),
        minHeight: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          borderBottom: `1px solid ${ld("#EEF0F3", "#2c2f33")}`,
          overflowX: "auto",
          flexShrink: 0,
        }}
      >
        {tabs.map((tab) => {
          const active: boolean = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => {
                setActiveTab(tab.key);
              }}
              className="mkhero-doc-tab"
              style={{
                position: "relative",
                flexShrink: 0,
                padding: "10px 11px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontFamily: H.sans,
                fontSize: 11.5,
                fontWeight: active ? 600 : 500,
                color: active ? H.accent : H.inkDim,
              }}
            >
              {tab.label}
              {active ? (
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: 2,
                    background: H.accent,
                    borderRadius: "2px 2px 0 0",
                  }}
                />
              ) : null}
            </button>
          );
        })}
      </div>
      <div style={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <DokumenteDetailTabPanel tab={activeTab} fixture={props.fixture} />
      </div>
    </div>
  );
}
